<template>
  <div class="header" v-scroll-spy-active v-scroll-spy-link>
    <a class="header__link" href="#start" @click=" route() " style="display:none">Start</a>
    <a class="header__link" href="#aktuelles" @click=" route() "><span>Aktuelles</span></a>
    <a class="header__link" href="#ueber-uns" @click=" route() "><span>Über uns</span></a>
    <a class="header__link" href="#termine" @click=" route() "><span>Termine</span></a>
    <a class="header__link" href="#mitglied-werden" @click=" route() "><span>Mitglied werden</span></a>
    <a class="header__link" href="#kontakt" @click=" route() "><span>Kontakt</span></a>
    <a class="header__link header__link--image" href="#start" @click=" route() ">
      <img :src=" logo " alt="Logo"
           class="header__link__image">
    </a>
  </div>
</template>

<script>
  export default {
    name: 'Sidebar',
    props: ['logo'],
    computed: {
      onepage () {
        return this.$route.path === '/'
      }
    },
    methods: {
      route() {
        if (!this.onepage) this.$router.push('/')
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .header {
    background: linear-gradient(to bottom, rgba(black, .3), rgba(black, .3)), $primary url(../../assets/backgrounds/sidebar-compressor.jpg);
    background-position: left center;
    background-size: cover;
    background-repeat: no-repeat;
    position: fixed;
    box-shadow: inset -15px 0 10px -10px rgba(black, .5);
    padding: 10rem 3rem 5rem;

    @media (max-width: 1200px) {
      padding: 6rem 1rem 3rem;
    }

    &__link {
      display: block;
      width: 100%;
      font-size: $size_title;
      color: rgba($text-inverse, .5);
      text-align: right;
      line-height: 1.1;

      @media (max-width: 1200px) {
        font-size: $size_text-big;
      }

      span {
        border-bottom: 1px solid transparent;
      }

      &.active span {
        border-bottom-color: currentColor;
      }
      &.active,
      &:hover,
      &:focus {
        border-bottom-color: transparent;
        color: $text-inverse;
        text-decoration: none;
      }

      & + & {
        margin-top: .75rem;
      }

      &--image {
        margin-top: 2rem !important;
        border-bottom: 0;

        @media (max-width: 1200px) {
          margin-top: 4rem !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/sidebar/index.vue